const ICON_FULL_RAW = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" {...props}>
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.9}
      d="M5.996.45h3.547v3.547M9.55.45.452 9.548M3.997 9.556H.45V6.009"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_FULL_RAW;
